module.exports = __webpack_public_path__ + "static/img/level_on.00a2dd3d.png";